import { IComponentsProps } from '../home';
import { ActionTypes, ILoadHotSiteResponse } from './types';

export function loadHotSite({ id, slug }: ILoadHotSiteResponse) {
  return {
    type: ActionTypes.loadHotSite,
    payload: {
      id,
      slug,
    },
  };
}

export function updateHotSite(componentes: IComponentsProps) {
  return {
    type: ActionTypes.updateHotSite,
    payload: {
      componentes,
    },
  };
}
